export default (history) => history.location.state || {};
